/* MDS Birthday Sale: add-ons. ONE rules engine + ONE inline row ("Stock up for Christmas"), shared by the cart drawer,
   the Bundle Builder bag (sidebar and mobile sheet) and the quiz. Ported from the prototype's components/addons.js
   (SPEC 10c, 2b, 6g; README items 15, 16). Markup: snippets/bds-addons.liquid. Styles: assets/bds-addons.css.

   Public API (keep it stable, the quiz depends on it):
     BDSAddons.pick(lines, spend?, opts?) -> [{ key, name, img, lines:[{handle,id}], full, now, pct, rule, why, unlock,
                                              reason, src, vid }]  ranked, at most opts.max (default 3)
         lines = cart items (/cart.js shape) or [{ handle, id, qty }]; gift lines (_bds_gift) are ignored.
         spend = the bag's sale total; omitted, it's worked out from the lines. pick(lines, opts) also works.
     BDSAddons.mount(el)   render the row into a [data-bds-addons] element (done automatically on load)
     BDSAddons.refresh()   re-render every mounted row (done automatically on cart:updated)
     BDSAddons.ROLES / KIT / PCT   the parsed "Add-on row products" setting (settings.bds_addon_roles)

   Rules (SPEC 10c), in priority order, then by price, top 3:
     1 hero    no Flow Timer (kits count) -> Flow Bundle, or Flow Timer when they already have cards or a tray
               no binder (kits count)     -> the 2027 planner bundle once priced, else the Planner Starter Pack
     2 parts   binder without inserts -> Daily insert; cards without a tray while the next tier isn't the tray -> tray
     3 protect a Flow Timer / Flow Bundle without a Carry Case -> Carry Case (the legacy Pomodoro doesn't count)
     4 gap     the candidate that reaches the next gift tier with the least sensible overshoot is promoted
     5 gifting Task & Time / Weeks & Habits when none (kits count); Focus insert for binder or insert owners; Weekly
               insert refill for insert owners
     6 extras  Cable Kit (held back while on BDS.noSuggest), Desk Pad small (AU only)
   Guards: in stock in this market, never on BDS.noSuggest, never already in the bag (kit contents count), never the
   tray once a gift tier gives it, no duplicates. Nothing is hard-coded: handles and variant ids come from the setting. */
(function (root) {
  if (root.BDSAddons) return;   // the snippet can render twice on a page (drawer + builder): one engine
  const B = root.BDS;
  if (!B) return;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- data: the setting (roles, kits) + the candidate products from Liquid ---------- */
  const ROLES = {}, KIT = {}, PCT = {};
  function parseRoles(txt) {
    String(txt || '').split(/\r?\n/).forEach((raw) => {
      const l = raw.trim(), i = l.indexOf('='); if (!l || i < 1) return;
      const k = l.slice(0, i).trim(), v = l.slice(i + 1).trim();
      if (k.indexOf('kit.') === 0) KIT[k.slice(4)] = v.split(/[\s,]+/).filter(Boolean);
      else if (k.indexOf('pct.') === 0) PCT[k.slice(4)] = v;
      else { const j = v.indexOf(':'); ROLES[k] = { handle: (j < 0 ? v : v.slice(0, j)).trim(), ids: j < 0 ? [] : v.slice(j + 1).split(',').map((x) => x.trim()).filter(Boolean) }; }
    });
  }
  function loadData() {
    const nodes = document.querySelectorAll('script[data-bds-addons-data]');
    let roles = null;
    nodes.forEach((n) => {
      let d; try { d = JSON.parse(n.textContent); } catch (e) { console.warn('[BDSAddons] bad data', e); return; }
      if (roles == null && d.roles) roles = d.roles;
      const P = root.BDS_PRODUCTS = root.BDS_PRODUCTS || [];
      (d.products || []).forEach((p) => {
        if (Array.isArray(P)) { if (!P.some((x) => x.handle === p.handle)) P.push(p); }
        else if (!P[p.handle]) P[p.handle] = p;
      });
    });
    if (roles != null) parseRoles(roles);
    else if (root.BDS_ADDON_ROLES) parseRoles(root.BDS_ADDON_ROLES);   // the quiz / a harness may provide the text directly
  }
  const products = () => { const P = root.BDS_PRODUCTS || []; return Array.isArray(P) ? P : Object.values(P); };
  const prod = (h) => products().find((p) => p.handle === h);
  // the exact variant (priceOf falls back to the first available one when the id isn't found, which we don't want here)
  const vInfo = (h, id) => { const p = B.priceOf(h, id); return p && String(p.variantId) === String(id) ? p : null; };
  const vRaw = (h, id) => { const p = prod(h); return p && (p.variants || []).find((v) => String(v.id) === String(id)); };
  const first = (h) => { const p = prod(h); if (!p) return null; for (const v of p.variants || []) { const i = vInfo(h, v.id); if (i && i.available) return i; } return null; };
  const roleV = (role) => { const r = ROLES[role]; if (!r) return null; return r.ids.length ? vInfo(r.handle, r.ids[0]) : first(r.handle); };
  const H = (role) => (ROLES[role] ? ROLES[role].handle : '\u0000' + role);

  // short card names (copy). Anything not listed uses the product title; inserts use their variant title.
  const LABEL = { timer: 'Flow Timer', bundle: 'Flow Bundle', case: 'Carry Case', tray: 'Card & Pencil Tray', 'task-time': 'Task & Time Cards',
    'weeks-habits': 'Weeks & Habits Cards', cable: 'Cable Kit', 'desk-small': 'Desk Pad, small' };

  /* ---------- candidates ---------- */
  function item(role, rule, why) {
    const r = ROLES[role], v = roleV(role); if (!r || !v || !v.available) return null;
    const h = r.handle, p = prod(h) || {}, raw = vRaw(h, v.variantId) || {}, insert = /^insert-/.test(role);
    return { key: r.ids.length ? h + ':' + v.variantId : h, role, name: insert ? String(v.title).replace(/ \(.*\)/, '') + ' insert' : (LABEL[role] || p.title || h),
      img: raw.image || p.image || (p.featured_image && (p.featured_image.src || p.featured_image)) || '', lines: [{ handle: h, id: v.variantId }],
      full: v.full, now: v.sale, pct: v.pct, rule, why, src: h, vid: v.variantId };
  }
  function starterPack(rule, why) {
    const c = ROLES['starter-cover'], ins = ROLES['starter-inserts']; if (!c || !ins || !c.ids.length || !ins.ids.length) return null;
    const L = [{ handle: c.handle, id: c.ids[0] }].concat(ins.ids.map((id) => ({ handle: ins.handle, id })));
    const V = L.map((l) => vInfo(l.handle, l.id)); if (!V.every((v) => v && v.available)) return null;
    const full = Math.round(V.reduce((a, v) => a + v.full, 0) * 100) / 100, ph = PCT.starter || c.handle;
    const sys = Object.keys(KIT).find((k) => KIT[k].includes('binder')), cover = vRaw(c.handle, c.ids[0]) || {};
    return { key: 'starter-pack', role: 'starter', name: 'Planner Starter Pack', img: cover.image || (prod(c.handle) || {}).image || '', lines: L.map((l) => ({ handle: l.handle, id: Number(l.id) || l.id })),
      // priced per line, each discount rounded down to the cent as the cart does it (A$80.80, not 80.76 off the summed full price)
      full, now: Math.round(V.reduce((a, v) => a + B.salePrice(v.full, ph), 0) * 100) / 100, pct: B.pctFor(ph), rule, why, src: sys || c.handle };
  }
  // the 2027 bundles are still "Price coming" (BDS.pendingBundles, if a build defines it): the Starter Pack stands in
  function plannerBundle(rule, why) {
    const b = (B.pendingBundles || []).find((x) => /2027 Starter Pack|Kickstart/.test(x.name) && x.price && x.lines);
    if (b) return { key: 'p2027', role: 'planner2027', name: b.name, img: b.img, lines: b.lines, full: b.full || b.price, now: b.price, pct: b.pct || 0, rule, why };
    return starterPack(rule, why);
  }

  /* ---------- the engine ---------- */
  const isGift = (l) => !!(l && l.properties && l.properties._bds_gift);
  function normLines(lines) {
    return (lines || []).filter((l) => l && !isGift(l)).map((l) => ({ handle: l.handle, id: String(l.variant_id != null ? l.variant_id : l.id), qty: l.quantity || l.qty || 1, raw: l }));
  }
  function spendOf(lines, L) {
    if ((lines || []).some((l) => l && l.key && l.variant_id != null) && B.cart && B.cart.totals) return B.cart.totals({ items: lines }).spend;
    return Math.round(L.reduce((a, l) => { const p = B.priceOf(l.handle, l.id); return a + (p ? p.sale * l.qty : 0); }, 0) * 100) / 100;
  }
  function pick(lines, spend, opts) {
    if (spend && typeof spend === 'object') { opts = spend; spend = undefined; }
    opts = opts || {};
    if (!Object.keys(ROLES).length) loadData();
    const L = normLines(lines);
    if (spend == null || isNaN(spend)) spend = spendOf(lines, L);
    const has = (role) => L.some((l) => l.handle === H(role));
    // what each kit contains, ONE table (KIT, from the live "What's included"): a kit's parts count as owned
    const owns = (role) => L.some((l) => l.handle === H(role) || (KIT[l.handle] || []).includes(role) ||
      (/^insert-/.test(role) && (KIT[l.handle] || []).some((r) => /^insert-/.test(r))));
    const hasTimer = owns('timer'), hasBinder = owns('binder'), hasInserts = owns('insert-daily');   // any variant of the inserts product, or a kit that contains inserts
    const hasTT = owns('task-time'), hasWH = owns('weeks-habits'), hasTray = owns('tray'), hasCards = hasTT || hasWH;
    const s = B.state(spend), T = B.M().tiers, C = [];
    // 1 hero
    if (!hasTimer) C.push(hasCards || hasTray ? item('timer', 1, 'Times every block') : item('bundle', 1, 'Timer, tray and cards'));
    if (!hasBinder) C.push(plannerBundle(1, 'Plan next year on paper'));
    // 2 parts
    if (hasBinder && !hasInserts) C.push(item('insert-daily', 2, 'Pages for your binder'));
    // the card tray is a product again, not a gift tier (Sam, 16 Oct: the tiers are the pencil, then the coasters)
    if (hasCards && !hasTray) C.push(item('tray', 2, 'Holds your cards'));
    // 3 protect it: only a Flow Timer (or the Flow Bundle's), never the legacy Pomodoro in the older kits
    if (hasTimer && !has('case')) C.push(item('case', 3, 'Protects your timer'));
    // 5 gifting / season
    if (!hasTT) C.push(item('task-time', 5, 'An easy stocking filler'));
    if (!hasWH) C.push(item('weeks-habits', 5, 'An easy stocking filler'));
    if (hasBinder || hasInserts) C.push(item('insert-focus', 5, 'New: sort tasks by priority'));
    if (hasInserts) C.push(item('insert-weekly', 5, 'A refill for the new year'));
    // 6 cheap extras
    if (!has('cable')) C.push(item('cable', 6, 'Tidies the cables'));
    if (B.M().iso === 'AU' && !has('desk-small')) C.push(item('desk-small', 6, 'A small desk upgrade'));
    // guards: in stock (item() returns null otherwise), nothing in the bag, never on noSuggest, no duplicates
    const seen = new Set(), held = new Set(B.noSuggest || []);
    const inBag = (c) => c.lines.every((x) => L.some((l) => l.handle === x.handle && String(l.id) === String(x.id)));
    const heldBack = (c) => c.lines.some((x) => held.has(x.handle));
    const list = C.filter((c) => c && !inBag(c) && !heldBack(c) && !seen.has(c.key) && seen.add(c.key));
    // 4 gap to the next gift: the note only where the overshoot is sensible (at most the gap again, or half the
    // free-shipping threshold), and the closest fit from the lower rules is promoted to rule 4
    if (s.next != null) {
      const gap = T[s.next] - spend, nextName = s.next === 0 ? 'shipping' : (B.gifts[B.tiers[s.next].gifts[0]] || {}).proper ? B.tiers[s.next].label : B.tiers[s.next].label.toLowerCase();
      list.forEach((c) => { if (c.now >= gap && c.now <= gap + Math.max(gap, T[0] / 2)) c.unlock = 'unlocks free ' + nextName; });
      const fit = list.filter((c) => c.unlock && c.rule > 4).sort((a, b) => a.now - b.now)[0];
      if (fit) { fit.rule = 4; fit.why = 'Closes the gap'; }
    }
    list.forEach((c) => { c.reason = note(c); });
    list.sort((a, b) => a.rule - b.rule || a.now - b.now);
    return list.slice(0, opts.max || CFG.max);
  }
  const roleOfHandle = (h) => Object.keys(ROLES).find((r) => ROLES[r].handle === h) || '';
  const note = (c) => (c.unlock ? `Adds ${B.money(c.now, true)} · ${c.unlock}` : c.why);
  const CFG = { max: 3 };

  /* ---------- the inline row ---------- */
  const cd = () => { const k = B.clock(); return k.phase === 'before' ? `Deal starts in ${k.text}` : `Deal ends ${k.text}`; };
  const pill = () => (B.clock().live ? `<span class="bds-ao__cd" data-ao-cd>${esc(cd())}</span>` : '');
  const ZOOM = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4.2-4.2"/></svg>';
  const rate = (c) => { const p = c.src && prod(c.src); return p && p.rating ? `<span class="bds-ao__rate"><i aria-hidden="true">★</i> ${esc(p.rating)}</span> · ` : ''; };
  // After ADD the card keeps its slot and its button becomes the shared stepper (V9.6). Each surface keeps the cards it
  // last showed plus which of them were added from it; the rest refill from fresh picks, so nothing reshuffles.
  const ROWS = {}, added = new Set(), busy = new Set();
  const cartQty = (h, id) => (B.cart && B.cart.qty ? B.cart.qty(h, id) : 0);
  const inCart = (c) => c.lines.every((l) => cartQty(l.handle, l.id) > 0);
  const linesKey = (L) => JSON.stringify(L.map((l) => ({ handle: l.handle, id: l.id })));
  let pendingFocus = null;

  function card(c) {
    const lj = linesKey(c.lines);
    const buy = c.inBag && B.qtyStep ? B.qtyStep(c.lines, { name: c.name, cls: 'bds-qs--ao' })
      : `<button type="button" class="bds-ao__add" data-ao-add="${esc(lj)}" data-ao-key="${esc(c.key)}" aria-label="Add ${esc(c.name)}"${busy.has(c.key) ? ' aria-busy="true"' : ''}>Add</button>`;
    const zoom = c.src && root.BDSProductModal ? `<button type="button" class="bds-ao__zoom" data-ao-view="${esc(c.src)}" data-ao-vid="${esc(c.vid || '')}" aria-label="See details: ${esc(c.name)}">${ZOOM}</button>` : '';
    return `<div class="bds-ao__c${c.inBag ? ' is-in' : ''}" data-rule="${c.rule}" data-ao-card="${esc(c.key)}">
      <span class="bds-ao__img">${c.img ? `<img src="${esc(c.img)}" alt="" loading="lazy" width="60" height="60">` : ''}${c.pct ? `<span class="bds-ao__pct">${c.pct}% off</span>` : ''}${zoom}</span>
      <span class="bds-ao__t"><b>${esc(c.name)}</b><small class="${c.unlock && !c.inBag ? 'is-unlock' : ''}">${c.inBag ? 'In your bag' : rate(c) + esc(note(c))}</small>
        <span class="bds-ao__buy"><span class="bds-ao__pr">${B.money(c.now, true)}${c.full > c.now ? ` <s>${B.money(c.full, true)}</s>` : ''}</span>${buy}</span></span></div>`;
  }
  /* desktop mouse affordance: prev/next arrows (CSS hides them on touch); synced by syncNav(). They sit at the end
     of the heading line, after the countdown pill, above the row: over the rail's edges they covered the first card's
     photo and the second card's text, and neither the bag's 22px nor the drawer's 28px gutter holds a button. */
  const CHEV = (d) => `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d < 0 ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6'}"/></svg>`;
  const nav = (d) => `<button type="button" class="bds-ao__nav bds-ao__nav--${d < 0 ? 'prev' : 'next'}" data-ao-nav="${d}" aria-label="${d < 0 ? 'Previous' : 'More'} suggestions" hidden>${CHEV(d)}</button>`;
  function html(ctx, lines, spend) {
    const max = CFG.max, fresh = pick(lines, spend, { max: 20 }), byKey = new Map(fresh.map((c) => [c.key, c]));
    // hidden when nothing qualifies, i.e. every suggestion is already in the bag (SPEC 2b: the pill goes with it)
    if (!fresh.length) { ROWS[ctx] = []; return ''; }
    const out = [];
    (ROWS[ctx] || []).forEach((c) => { if (added.has(c.key) && inCart(c)) out.push(Object.assign({}, c, { inBag: true })); else if (byKey.has(c.key)) out.push(byKey.get(c.key)); });
    fresh.forEach((c) => { if (out.length < max && !out.some((x) => x.key === c.key)) out.push(c); });
    const picks = out.slice(0, max); ROWS[ctx] = picks;
    return `<section class="bds bds-ao bds-ao--${esc(ctx)}" aria-label="Stock up for Christmas">
      <div class="bds-ao__h"><b>Stock up for Christmas</b><span class="bds-ao__hr">${pill()}<span class="bds-ao__navs" hidden>${nav(-1)}${nav(1)}</span></span></div>
      <p class="bds-ao__sub">Extended 48 hours. Birthday prices end ${esc(B.endLabel())}.</p>
      <div class="bds-ao__rail"><div class="bds-ao__row">${picks.map(card).join('')}</div></div></section>`;
  }

  const mounted = new Set();
  function render(el) {
    const ctx = el.dataset.context || 'cart', st = B.cart && B.cart.state;
    // context engine (the layout) and quiz only load the engine (BDSAddons.pick / .row); they draw nothing here
    if (!B.sale.active || !st || ctx === 'quiz' || ctx === 'engine') { el.innerHTML = ''; el.hidden = true; return; }
    const out = html(ctx, st.items || [], B.cart.spend(st));
    // keep the horizontal scroll position across re-renders
    const sc = el.querySelector('.bds-ao__row'), x = sc ? sc.scrollLeft : 0;
    el.innerHTML = out; el.hidden = !out;
    const nsc = el.querySelector('.bds-ao__row'); if (nsc && x) nsc.scrollLeft = x;
    // the arrows depend on the row's width, which is 0 while the drawer is closed: resync whenever it resizes
    if (el.__aoRo) el.__aoRo.disconnect();
    if (nsc) { syncNav(nsc); if (root.ResizeObserver) { el.__aoRo = new ResizeObserver(() => syncNav(nsc)); el.__aoRo.observe(nsc); } }
    if (pendingFocus) { const n = [...el.querySelectorAll('.bds-ao__c.is-in [data-qs="1"]')].find((b) => b.dataset.qsLines === pendingFocus); if (n) { n.focus({ preventScroll: true }); pendingFocus = null; } }
  }
  function mount(el) { if (!el) return; mounted.add(el); el.__bdsAo = true; render(el); }
  function scan() { document.querySelectorAll('[data-bds-addons]').forEach((el) => { if (!el.__bdsAo) mount(el); }); }
  function refresh() { [...mounted].forEach((el) => { if (!el.isConnected) mounted.delete(el); else render(el); }); scan(); }

  /* ---------- adds ---------- */
  let lastAdd = 0;
  async function addLines(L, key) {
    const now = Date.now(); if (now - lastAdd < 400) return; lastAdd = now;   // the same 400ms tap guard as every other Add
    if (key) { added.add(key); busy.add(key); }
    try {
      if (B.cart && B.cart.addMany) await B.cart.addMany(L.map((l) => ({ handle: l.handle, id: l.id, qty: 1, properties: { _bundle: 'birthday' } })));
      else {
        const r = await fetch((B.routes ? B.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: L.map((l) => ({ id: Number(l.id), quantity: 1, properties: { _bundle: 'birthday' } })) }) });
        if (!r.ok) throw new Error('add failed');
        const c = await (await fetch((B.routes ? B.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
      }
    } catch (e) {
      console.warn('[BDSAddons] add failed', e);
      if (key) added.delete(key);
    } finally { if (key) busy.delete(key); refresh(); }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ao-add]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.getAttribute('aria-busy') === 'true') return;
    const L = JSON.parse(b.dataset.aoAdd);
    if (document.activeElement === b) pendingFocus = linesKey(L);   // keyboard: focus lands on the new stepper's +
    b.setAttribute('aria-busy', 'true');
    addLines(L, b.dataset.aoKey);
  }, true);
  // the magnifier opens the shared product modal (builder and quiz load it; elsewhere the button isn't drawn)
  document.addEventListener('click', (e) => {
    const z = e.target.closest('[data-ao-view]'); if (!z) return;
    const PM = root.BDSProductModal, C = B.cart; if (!PM || !C) return;
    e.preventDefault(); e.stopPropagation();
    const h = z.dataset.aoView, vid = z.dataset.aoVid ? Number(z.dataset.aoVid) : undefined;
    const add = (hh, id) => C.addMany([{ handle: hh, id, qty: 1, properties: { _bundle: 'birthday' } }]);
    const dec = (hh, id) => C.decMany([{ handle: hh, id }]);
    if (/^insert-/.test(roleOfHandle(h)) && vid && PM.insert) {
      const p = vInfo(h, vid);
      return PM.insert(vid, { price: p ? p.sale : undefined, soldOut: p ? !p.available : false, qty: () => C.qty(h, vid), onAdd: () => add(h, vid), onQty: (d) => (d > 0 ? add(h, vid) : dec(h, vid)) });
    }
    PM.open(h, { variantId: vid, addLabel: 'Add to bag', context: 'builder', qty: (hh, id) => C.qty(hh, id), onAdd: add, onQty: (hh, id, d) => (d > 0 ? add(hh, id) : dec(hh, id)) });
  }, true);

  /* ---------- scrolling with a mouse: arrows + click-and-drag ---------- */
  function syncNav(row) {
    const ao = row.closest('.bds-ao'); if (!ao) return;
    const max = row.scrollWidth - row.clientWidth;
    const p = ao.querySelector('[data-ao-nav="-1"]'), n = ao.querySelector('[data-ao-nav="1"]');
    // the row's first snap point sits a couple of px in (its 2px padding, sub-pixel zoom): within 6px of an end IS that end,
    // so the start never shows Previous
    if (p) p.hidden = row.scrollLeft <= 6;
    if (n) n.hidden = row.scrollLeft >= max - 6;
    // a row that fits shows no arrows and keeps no room for them
    const g = ao.querySelector('.bds-ao__navs'); if (g) g.hidden = max <= 6;
  }
  const reduced = () => root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ao-nav]'); if (!b) return;
    const ao = b.closest('.bds-ao'), row = ao && ao.querySelector('.bds-ao__row'); if (!row) return;
    e.preventDefault();
    const c = row.querySelector('.bds-ao__c'), step = c ? c.offsetWidth + 8 : row.clientWidth * 0.8;
    row.scrollBy({ left: Number(b.dataset.aoNav) * step, behavior: reduced() ? 'auto' : 'smooth' });
  });
  // scroll doesn't bubble; listen in capture to keep the arrows in step with drags, wheel and trackpad
  document.addEventListener('scroll', (e) => { const t = e.target; if (t && t.classList && t.classList.contains('bds-ao__row')) syncNav(t); }, true);
  // mouse drag: native swipe covers touch and trackpads, so only a primary mouse button drags. A drag past 5px
  // swallows the click it ends on, so dropping on ADD or the magnifier doesn't fire them.
  let drag = null, dragEndAt = 0;
  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    const row = e.target.closest('.bds-ao__row'); if (!row || row.scrollWidth <= row.clientWidth) return;
    drag = { row, id: e.pointerId, x: e.clientX, left: row.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    const dx = e.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 5) return;
      drag.moved = true; drag.row.classList.add('is-drag');
      try { drag.row.setPointerCapture(e.pointerId); } catch (_) {}
    }
    drag.row.scrollLeft = drag.left - dx;
  });
  const endDrag = (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    const d = drag; drag = null;
    if (d.moved) { d.row.classList.remove('is-drag'); dragEndAt = Date.now(); }   // dropping the class re-enables snap
  };
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  // window capture runs before the document-level ADD / magnifier handlers
  root.addEventListener('click', (e) => {
    if (Date.now() - dragEndAt < 300 && e.target.closest && e.target.closest('.bds-ao__row')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('dragstart', (e) => { if (e.target.closest && e.target.closest('.bds-ao__row')) e.preventDefault(); });

  /* ---------- wiring ---------- */
  document.addEventListener('cart:updated', () => {
    // the drawer's own add response can be partial: BDS.cart re-reads; render once the full cart is in
    if (B.cart && B.cart.state && B.cart.state.items) refresh();
    else if (B.cart && B.cart.get) B.cart.get().then(refresh).catch(() => {});
  });
  document.addEventListener('bds:cart:ready', refresh);
  // one heartbeat (SPEC 2b): the pill repaints on the sale clock's whole second; the row goes when the sale ends
  let wasActive = B.sale.active;
  B.everySecond(() => {
    const live = B.clock().live;
    document.querySelectorAll('[data-ao-cd]').forEach((n) => { if (!live) n.remove(); else { const t = cd(); if (n.textContent !== t) n.textContent = t; } });
    if (B.sale.active !== wasActive) { wasActive = B.sale.active; refresh(); }
  });
  // the drawer re-renders its body: mount any new [data-bds-addons]
  const mo = new MutationObserver(scan);

  function init() {
    loadData();
    scan();
    mo.observe(document.body, { childList: true, subtree: true });
    if (B.cart && !B.cart.state && B.on && root.fetch && location.protocol !== 'file:') B.cart.get().then(refresh).catch(() => {});
  }
  root.BDSAddons = { pick, mount, refresh, ROLES, KIT, PCT, CFG, parseRoles, loadData };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})(window);
